let elements = {
  withoutReset: true,
  mainImage: {
    imagePath: 'games/page766_game0/img/bcg.jpg',
    pos: {
      x: 180,
      y: 0,
    },
    width: 1554,
    height: 1080,
  },
  withoutCheck: true,
  //imageHighlight: false,
  //imageHighlightColor: 'red',
  mbAudioItemData: [
    {
      src: 'games/page766_game0/audio/71_Christmas tree.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game0/img/audioOn.png', iconOff: 'games/page766_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 890,
        x: 920,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game0/audio/72_baubles.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game0/img/audioOn.png', iconOff: 'games/page766_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 930,
        x: 1350,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game0/audio/73_bells.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game0/img/audioOn.png', iconOff: 'games/page766_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 450,
        x: 1630,
      },
      unit: 'px',
    },
    {
      src: 'games/page766_game0/audio/74_stars.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page766_game0/img/audioOn.png', iconOff: 'games/page766_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '40px',
      height: '40px',
      pos: {
        y: 850,
        x: 735,
      },
      unit: 'px',
    },
  ],
};

export default elements;
